
import { lazy } from 'react';



const CompanyInvoicesConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/companyinvoices',
      component: lazy(() => import('./CompanyInvoices')),
    },
  ],
};

export default CompanyInvoicesConfig

